"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderWithAdaptableContext = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_redux_1 = require("react-redux");
const styled_components_1 = require("styled-components");
const theme_1 = tslib_1.__importDefault(require("../theme"));
const AdaptableContext_1 = tslib_1.__importDefault(require("./AdaptableContext"));
const renderWithAdaptableContext = (children, adaptable) => {
    return (React.createElement(react_redux_1.Provider, { store: adaptable.adaptableStore.TheStore },
        React.createElement(styled_components_1.ThemeProvider, { theme: theme_1.default },
            React.createElement(AdaptableContext_1.default.Provider, { value: adaptable }, children))));
};
exports.renderWithAdaptableContext = renderWithAdaptableContext;
